<script setup lang="ts">
import PricingBreakdown from '@/components/booking/PricingBreakdown.vue';
</script>

<template>
  <div aria-hidden="true">
    <div class="hold">
      <span class="yb-skeleton skeleton-hold-icon" />
    </div>

    <div class="skeleton-product-info">
      <div class="yb-skeleton skeleton-avatar" />
      <div class="skeleton-product-text">
        <span class="yb-skeleton skeleton-title" />
        <span class="yb-skeleton skeleton-date" />
        <span class="yb-skeleton skeleton-persons" />
      </div>
    </div>

    <div class="yb-skeleton skeleton-state-container" />

    <hr aria-hidden="true">
  </div>
  <PricingBreakdown
    :units="[]"
    :loading="true"
  />
</template>

<style scoped lang="css">
.hold {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.skeleton-hold-icon {
  width: 42px;
  height: 42px;
}

.skeleton-product-info {
  display: flex;
  align-items: center;
  gap: var(--yb-spacing-base);
  margin: var(--yb-spacing-xs) 0;
}

.skeleton-avatar {
  width: 60px;
  height: 60px;
  flex-shrink: 0;
}

.skeleton-product-text {
  display: flex;
  flex-direction: column;
  gap: var(--yb-spacing-xs);
  flex: 1;
}

.skeleton-title {
  width: 70%;
  height: 18px;
}

.skeleton-date {
  width: 50%;
  height: 14px;
}

.skeleton-persons {
  width: 30%;
  height: 14px;
}

.skeleton-state-container {
  width: 100%;
  height: 72px;
}

hr {
  width: 100%;
  border: 1px solid var(--yb-color-lightgray);
}
</style>
